<div class="custom-modal">
  <div class="header" *ngIf="data.titulo">
    <h1 mat-dialog-title>{{data.titulo}}</h1>
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>
  <mat-divider *ngIf="data.titulo"></mat-divider>
  <div mat-dialog-content>
    <p [hidden]="data.diasExpiracaoSenha <= 0">
      Se deseja continuar, clique em CONTINUAR.<br />
      Caso contrário, clique em Atualizar para cadastrar nova senha e depois em Confirmar.
    </p>
    <p [hidden]="data.diasExpiracaoSenha >= 1 && data.diasExpiracaoSenha <= 5">
      Clique em Atualizar para cadastrar nova senha e depois em Confirmar
    </p>
    <form *ngIf="camposNovaSenha" [formGroup]="formAtualizarSenha">
      <mat-form-field appearance="outline" class="password-input full-width">
        <mat-label>Nova Senha</mat-label>
        <input matInput placeholder="Nova senha" [(ngModel)]="password" name="password" formControlName="newPassword" [type]="hide ? 'password' : 'text'" required #inputPassword />
          <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>
              {{ hide ? "visibility_off" : "visibility" }}
            </mat-icon>
          </button>
      </mat-form-field>
      <app-password-meter [password]="password" (buttonPassword)="passwordValid($event)"></app-password-meter>
      <mat-form-field appearance="outline" class="password-input full-width">
        <mat-label>Confirmar Senha</mat-label>
        <input matInput placeholder="Confirmar Senha" [(ngModel)]="confirmPassword" name="confirmPassword" formControlName="newConfirmPassword" [type]="hide ? 'password' : 'text'" required #inputPassword />
          <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>
              {{ hide ? "visibility_off" : "visibility" }}
            </mat-icon>
          </button>
      </mat-form-field>
    </form>
  </div>
  <div class="modal-actions" mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [hidden]="camposNovaSenha" (click)="showNovaSenha()">Atualizar</button>
    <button *ngIf="camposNovaSenha" [disabled]="!passwordIsValid || formAtualizarSenha.invalid" (click)="confirmar()" mat-flat-button color="primary" >Confirmar</button>
    <button *ngIf="!camposNovaSenha" [disabled]="data.diasExpiracaoSenha <= 0" (click)="confirm()" mat-flat-button color="primary" mat-dialog-close>Continuar</button>
  </div>
</div>
